export default {
	activate: "Activate",
	deactivate: "Deactivate",
	delete: "Delete",
	edit: "Edit",
    selected: "selected"
};
